<template>
    <div>
        <Message
            :time="this.time"
            :message="this.message"
            :messageHeader="this.messageHeader"
        ></Message>
        <el-row type="flex" justify="end" align="middle" class="mt-10">
            <el-button @click="switchRoom" type="primary">Switch</el-button>
            <el-button @click="cancel" type="text">Cancel</el-button>
        </el-row>
    </div>
</template>

<script>
import Message from './Message';
import axios from '../../client';

export default {
    name: 'LastNPrompt',
    components: {
        Message
    },
    props: ['time', 'message', 'messageHeader', 'type','currentRoom','mainRoom'],
    data: function() {
        return {};
    },
    computed:{
    },
    methods: {
        async switchRoom() {
            if (this.type == 'standard') {
                await this.setLastNIfAllowed(process.env.VUE_APP_NORMAL_VIDEO_MODE)
            } else if (this.type == 'expanded') {
                await this.setLastNIfAllowed(process.env.VUE_APP_EXPANDED_VIDEO_MODE);
            }
            this.$notify.closeAll();
        },
        async setLastNIfAllowed(lastN) {
            if (this.isActionAllowed()) {
                await this.setLastN(lastN);
            }
        },
        async setLastN(lastN) {
            try {
                await axios.put('/api/rooms/' + this.currentRoom._id, {
                    lastN,
                    mainRoom: this.mainRoom.name,
                });
            } catch (err) {
                if (err.response.data.message === 'TOKEN_EXPIRED') {
                    this.$store.dispatch('user/refreshTokens', this.setLastN);
                } else {
                    alert(err);
                }
            }
        },
        isActionAllowed() {
            if (
                this.isLastNEnable() &&
                this.currentRoom.participants.length >
                    this.currentRoom.normalRoomParticipantsLimit
            ) {
                return false;
            }
            return true;
        },
        isLastNEnable() {
            return this.currentRoom.lastN == process.env.VUE_APP_EXPANDED_VIDEO_MODE;
        },
        cancel() {
            this.$notify.closeAll();
        },
    },
};
</script>

<style scoped>
.mt-10 {
    margin-top: 10px;
}
</style>
